export default __webpack_public_path__ + "static/media/Rolling-1s-62px.89c89d9f.svg";